module.exports = __webpack_public_path__ + "static/media/indentplanner1.396c750c.png";